import { render, staticRenderFns } from "./RegistrarCuenta.vue?vue&type=template&id=52e8ea9c&scoped=true&lang=pug"
import script from "./RegistrarCuenta.vue?vue&type=script&lang=js"
export * from "./RegistrarCuenta.vue?vue&type=script&lang=js"
import style0 from "./RegistrarCuenta.vue?vue&type=style&index=0&id=52e8ea9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e8ea9c",
  null
  
)

export default component.exports